// extracted by mini-css-extract-plugin
export default {"banner":"ArchivedYearGroupBanner__banner___JY2kg"};